import React, { useEffect } from 'react'

import { Field } from 'formik'

import { Select } from '@driftt/tide-selects'

import CheckboxRow from './CheckboxRow'

import styles from '../styles.module.css'

const MultiSelectCheckboxRow: React.FC<any> = ({
  checkBoxField,
  options,
  form,
  label,
  selectFieldName = '',
  onCheckboxChange = null,
  ...rest
}) => {
  const { setFieldValue } = form
  useEffect(() => {
    if (onCheckboxChange) {
      checkBoxField.value && onCheckboxChange()
    } else {
      !checkBoxField.value && setFieldValue(selectFieldName, [])
    }
  }, [checkBoxField.value, setFieldValue, selectFieldName, onCheckboxChange])

  return (
    <CheckboxRow
      {...rest}
      field={checkBoxField}
      form={form}
      content={
        <div>
          <div>{label}</div>
          <div>
            <Field name={selectFieldName}>
              {({ field, form }: any) => (
                <Select
                  className={styles.select}
                  isSearchable={true}
                  isMulti={true}
                  size={'small'}
                  value={options.filter((item: any) => field.value?.includes(item.value))}
                  onChange={(values: Record<string, string>[]) => {
                    form.setFieldValue(
                      selectFieldName,
                      values.map(item => item.value)
                    )
                  }}
                  placeholder="Select...."
                  options={options}
                  isDisabled={!checkBoxField.value}
                />
              )}
            </Field>
          </div>
        </div>
      }
    />
  )
}

export default MultiSelectCheckboxRow
